module.exports = __webpack_public_path__ + "media/images/popup_new_client-15b52d44de43654e771a5ed1b6fa204a.jpg";